/* eslint-disable no-undef */
// TODO check if it's ok to add env: { node: true } to the .eslintrc.js file
const apiConfig = {
    getAndQueryBaseUrl: process.env.REACT_APP_GET_AND_QUERY_API_BASE_URL || 'http://localhost:8070/',
    validateAndPersistBaseUrl: process.env.REACT_APP_VALIDATE_AND_PERSIST_API_BASE_URL || 'http://localhost:8090/',
    integrationsUrl: process.env.REACT_APP_INTEGRATIONS_API_BASE_URL || 'http://localhost:8060/',
};

export default apiConfig;